import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TurmaCatequizandoDto } from './turma-catequizando.dto';

@Injectable({ providedIn: 'root' })
export class TurmaCatequizandoService {
  private readonly apiUrl = `${environment.api}/turmas-catequizandos`;

  constructor(private http: HttpClient) {}

  /** Unifica o id de foto que o backend pode expor em nomes diferentes (JSON camelCase). */
  private static coalesceFotoDocumentoId(raw: Record<string, unknown>): string | null {
    const keys = ['fotoDocumentoId', 'fotoId', 'idFoto', 'pessoaFotoDocumentoId'] as const;
    for (const k of keys) {
      const v = raw[k];
      if (v != null && String(v).trim() !== '') {
        return String(v);
      }
    }
    return null;
  }

  private normalizeDto(raw: unknown): TurmaCatequizandoDto {
    if (raw == null || typeof raw !== 'object') {
      return raw as TurmaCatequizandoDto;
    }
    const r = raw as Record<string, unknown>;
    const base = { ...(raw as object) } as TurmaCatequizandoDto;
    base.fotoDocumentoId = TurmaCatequizandoService.coalesceFotoDocumentoId(r);
    return base;
  }

  /**
   * GET `/turmas-catequizandos?turmaId=<uuid>` alinhado ao Spring:
   * `listar(@RequestParam UUID turmaId)` — o parâmetro é **obrigatório**
   * (sem ele o backend responde 400).
   */
  listar(turmaId: string): Observable<TurmaCatequizandoDto[]> {
    const id = turmaId?.trim();
    if (!id) return of([]);
    return this.http
      .get<unknown[]>(this.apiUrl, { params: new HttpParams().set('turmaId', id) })
      .pipe(
      map((rows) => (Array.isArray(rows) ? rows.map((item) => this.normalizeDto(item)) : [])),
    );
  }

  matricular(turmaId: string, pessoaId: string): Observable<TurmaCatequizandoDto> {
    return this.http
      .post<unknown>(`${this.apiUrl}/matricular`, { turmaId, pessoaId })
      .pipe(map((body) => this.normalizeDto(body)));
  }

  desmatricular(turmaId: string, pessoaId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/turma/${turmaId}/pessoa/${pessoaId}`);
  }

  transferir(body: { turmaSaida: string; turmaEntrada: string; pessoa: string }): Observable<TurmaCatequizandoDto> {
    return this.http.post<unknown>(`${this.apiUrl}/transferir`, body).pipe(map((res) => this.normalizeDto(res)));
  }
}
